// Generated by purs version 0.15.0
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Restaumatic_Address from "../Restaumatic.Address/index.js";
var toStoredDeliveryAddress = function (x) {
    return {
        street: Data_Maybe.Just.create(x.street),
        streetNumber: Data_Maybe.Just.create(x.streetNumber),
        city: Data_Maybe.Just.create(x.city),
        postCode: Data_Maybe.Just.create(x.postCode),
        aptNumber: Data_Maybe.Just.create((Data_Newtype.unwrap()(x.extra)).aptNumber),
        floor: Data_Maybe.Just.create((Data_Newtype.unwrap()(x.extra)).floor),
        extra: Data_Maybe.Just.create(x.extra)
    };
};
var fromStoredDeliveryAddress = function (x) {
    var fromNullable = Data_Maybe.fromMaybe("");
    var floorNum = fromNullable(x.floor);
    var aptNum = fromNullable(x.aptNumber);
    var v = Data_Maybe.fromMaybe(Restaumatic_Address.emptyAddressExtra)(x.extra);
    var extraUpdated = {
        sector: v.sector,
        houseOrBlock: v.houseOrBlock,
        block: v.block,
        staircase: v.staircase,
        floor: (function () {
            var $3 = v.floor === "";
            if ($3) {
                return floorNum;
            };
            return v.floor;
        })(),
        aptNumber: (function () {
            var $4 = v.aptNumber === "";
            if ($4) {
                return aptNum;
            };
            return v.aptNumber;
        })(),
        interphone: v.interphone,
        additionalInfo: v.additionalInfo
    };
    return {
        street: fromNullable(x.street),
        streetNumber: fromNullable(x.streetNumber),
        city: fromNullable(x.city),
        postCode: fromNullable(x.postCode),
        extra: extraUpdated
    };
};
export {
    fromStoredDeliveryAddress,
    toStoredDeliveryAddress
};
//# sourceMappingURL=index.js.map
